























































































import {
  defineComponent,
  inject,
  reactive,
  toRefs,
  watch,
  ref,
} from '@vue/composition-api'

import { useStore as useUserStore } from '@/shared/state-management/userStore'
import { editUserData } from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'
import ChangePassword from '../components/user/ChangePassword.vue'
export default defineComponent({
  name: 'UserProfile',
  components: {
    ChangePassword,
  },
  setup(props, { root }) {
    const { getters, actions } = useUserStore()
    const { user, loading: loadingUser } = getters
    const { fetchUser } = actions
    const $alert = inject(alertSymbol) as Function
    const showChangePasswordDialog = ref(false)

    const userData = reactive({
      firstname: user.value ? user.value.firstname : '',
      lastname: user.value ? user.value.lastname : '',
    })
    const loading = ref(false)

    const submit = async () => {
      loading.value = true
      try {
        await editUserData(userData.firstname, userData.lastname)
        $alert({ type: 'success', text: root.$t('userProfile.editSuccess') })
        await fetchUser()
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    const onChangedPassword = () => {
      showChangePasswordDialog.value = false
    }

    watch(
      () => loadingUser.value,
      (newVal: boolean) => {
        if (!newVal) {
          userData.firstname = user.value ? user.value.firstname : ''
          userData.lastname = user.value ? user.value.lastname : ''
        }
      }
    )

    return {
      user,
      ...toRefs(userData),
      submit,
      loading,
      showChangePasswordDialog,
      onChangedPassword,
    }
  },
})
